export default __webpack_public_path__ + "static/media/264.3f0e6731.jpg";